var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportinline = function SvgSupportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#F25A5A",
    rx: 5.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2.25,
    d: "m12.722 32.424.14-.6-.43-.44C8 26.831 7.357 19.861 10.952 14.611c3.666-5.321 10.741-7.43 16.866-4.958 6.12 2.47 9.58 8.812 8.293 15.057-1.289 6.255-6.984 10.831-13.61 10.831h-.033c-1.732 0-3.4-.309-4.978-.895l-.557-.208-.485.343c-1.894 1.34-4.124 1.593-5.522 1.593h-.108c1.093-1.166 1.629-2.768 1.904-3.951Z"
  })));
};
export default SvgSupportinline;